import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationTransportadoraModalComponent } from './integration-transportadora-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationTransportadoraModalComponent
    ],
    exports: [
        IntegrationTransportadoraModalComponent
    ]
})
export class IntegrationTransportadoraSharedModule { }
